import HeaderItems from "./headerSliderUpdate/index";
import CarouselItems from "./carouselItemsUpdate/index";
import { Box, Container, Typography } from "@mui/material";

const Index = ({ lang }) => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main' }}>
          Ana Sayfa Resim Güncellemeleri
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <HeaderItems />
          <CarouselItems />
        </Box>
      </Box>
    </Container>
  );
};

export default Index;
